import { gql } from "@apollo/client";

export const UPDATE_USER_ACCOUNT_INFO = gql`
  mutation UpdateAccountInfo(
    $firstName: String!
    $lastName: String!
    $displayName: String!
    $slackEmail: String!
  ) {
    updateAccountInfo(
      firstName: $firstName
      lastName: $lastName
      displayName: $displayName
      slackEmail: $slackEmail
    ) {
      user {
        firstName
        lastName
        displayName
      }
    }
  }
`;
